import React, {useEffect, useState} from 'react';
import {insertPdvSale} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import {showAlert, showConfirm} from "../../core/dialog";

const PdvSaleManagerConfirmItems = () => {
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const saleCookie = localStorage.getItem('pdvSale');
    const newSale = {saleItems: []};
    const [sale] = useState(saleCookie ? JSON.parse(saleCookie) : newSale);
    const customerName = sale.customerName || (sale.customer?.name);
    const tableName = sale.table?.name;
    const customerCode = sale.customer?.code?.toString().padStart(3, '0');
    const [totalValue, setTotalValue] = useState(0);

    useEffect(() => {
        if (sale.saleItems) {
            const items = sale.saleItems.filter(p => p.quantity > 0 || p.quantity < 0);
            setFilteredProducts(items);
            const total = items.reduce((acc, p) => acc + ((p.product?.salePrice || 0) * (p.quantity || 0)), 0);
            setTotalValue(total);
        }
    }, []);

    const doConfirm = async () => {
        const saleItems = filteredProducts
            .filter(p => p.quantity > 0 || p.quantity < 0)
            .map(p => ({product: p.product, productName: p.product.name + (p.product.note ? ' ' + p.product.note : ''), quantity: p.quantity}));
        if (saleItems.length === 0) {
            showAlert('Nenhum item foi adicionado.');
            return;
        }
        if (!await showConfirm('Essa operação não poderá ser revertida. Deseja continuar?')) return;
        sale.saleItems = saleItems;
        await insertPdvSale(sale);
        localStorage.removeItem('pdvSale');
        navigate('/pdv/table');
    };

    const onConfirm = async () => {
        setLoading(true);
        await doConfirm();
        setLoading(false);
    };

    return (
        <>
            <div className="header-label" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <div>Confirmar pedido:</div>
                {tableName && <div>{tableName}</div>}
                {customerCode && <div>{customerName}</div>}
            </div>
            <table style={{width: '100%'}}>
                <colgroup>
                    <col style={{width: '500px'}}/>
                    <col style={{width: '50px'}}/>
                    <col style={{width: '50px'}}/>
                </colgroup>
                <thead>
                <tr>
                    <th>Nome</th>
                    <th>Qtd</th>
                    <th>Preço</th>
                </tr>
                </thead>
                <tbody>
                {filteredProducts.map((item, index) => (
                    <tr key={index} style={{backgroundColor: item.quantity > 0 ? 'var(--warning-color)' : item.quantity < 0 ? 'var(--error-color)' : 'white'}}>
                        <td><div>{item.product.name + (item.product.note ? ' ' + item.product.note : '')}</div></td>
                        <td>{item.quantity || 0}</td>
                        <td><div style={{textAlign: 'right'}}>{(item.product.salePrice || 0).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div></td>
                    </tr>
                ))}
                </tbody>
                {filteredProducts.length === 0 && <tfoot><tr><td colSpan={3}>Nenhum item encontrado</td></tr></tfoot>}
            </table>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div className="total-label" style={{textAlign: 'right', fontSize: '30px', color: '#cc5545'}}>
                    Valor Total: R$ {totalValue.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                </div>
            </div>
            <ActionButtonsManagerView>
                <button onClick={onConfirm} disabled={loading}>Confirmar</button>
            </ActionButtonsManagerView>
        </>
    );
};

export default PdvSaleManagerConfirmItems;
